import React, { useState } from 'react';
import PropTypes from "prop-types";
import { Radio, Tooltip } from 'antd';
import Popup from '../Popup/Popup';
import CharitySelectCard from './CharitySelectCard';
import { TableLabel, UnderlyingContent } from '../../../../Epics/Grants/Pages/RecommendGrant/style';
import { addressFormat } from '../../../../Epics/Grants/Pages/RecommendGrant/utils';
import { CommonTable } from '../../../commonStyles';
import { CardContainer } from '../../../../Epics/Grants/Pages/RecommendGrant/Component/RenderCard/style';

export default function MultipleCharity({
  show,
  primaryCta,
  secondaryCta,
  charities
}) {
  const [granteeOrgId, setGranteeOrgId] = useState("");
  const [selectedCharity, setSelectedCharity] = useState({});

  const tableConfig = [
    {
      title: () => <div></div>,
      dataIndex: "granteeOrgId",
      key: "granteeOrgId",
      render: (value, record) => (
      <div>
        <Radio
          name="multipleCharityRadio"
          value={value}
          checked={granteeOrgId === value}
          onChange={() => onCharitySelect(value, record)}
        />
      </div>
      ),
      width: "1%"
    },
    {
      title: () => <div>Legal Name</div>,
      dataIndex: "legalName",
      key: "legalName",
      render: value => (<TableLabel>{value} </TableLabel>),
      width: "36%",
    
    },
    {
      title: () => <div>EIN</div>,
      dataIndex: "ein",
      key: "ein",
      render: value => (<TableLabel>{value} </TableLabel>),
      width: "17%"
    },
    {
      title: () => <div>Address</div>,
      dataIndex: "location",
      key: "location",
      render: (value, record) => 
      (<Tooltip placement="bottomLeft" title={addressFormat({...record, zipCode: record.zip})}><UnderlyingContent>{`${record.city}, ${record.state}`}</UnderlyingContent></Tooltip>),
      width: "20%"
    },
    {
      title: () => <div>Interest Area</div>,
      dataIndex: "interestArea",
      key: "interestArea",
      render: value => (<TableLabel>{value} </TableLabel>),
      width: "18%"
    }
  ];

  const onCharitySelect = (value, record) => {
    setGranteeOrgId(value);
    setSelectedCharity(record);
  };

  const enablePrimary = () => {
    if (Object.keys(selectedCharity).length) {
      return true;
    }
    return false;
  }

  return (
    <Popup
      data-test="popup-test"
      popupTitle="Select charity"
      popupDesc="There are multiple charities under the same EIN number. Please select the one you want to go ahead with."
      renderDesktop={
        <CommonTable
          data-test="render-desktop"
          dataSource={charities}
          columns={tableConfig}
          pagination={false}
        />
      }
      renderMobile={
        charities.map((charity, index) => 
          <div>
            <CardContainer index={index}>
              <CharitySelectCard
                data-test="charityselectcard"
                key={charity.granteeOrgId}
                data={charity}
                granteeOrgId={granteeOrgId}
                onRadioChange={onCharitySelect}
              />
            </CardContainer>
          </div>
        )
      }
      show={show}
      onCancel={secondaryCta}
      primaryCta={() => primaryCta(selectedCharity)}
      enablePrimaryCta={enablePrimary()}
      primaryCtaLabel="Continue"
      secondaryCtaLabel="No, take me back"
    />
  )
}
MultipleCharity.propTypes = {
  charities: PropTypes.array,
  primaryCta: PropTypes.func,
  secondaryCta: PropTypes.any,
  show: PropTypes.any
}
